import { createContext, useContext } from "react";

export const LoaderContext = createContext();

const LoadingProvider = ({ children }) => {
  const noop = () => {};
  return (
    <LoaderContext.Provider value={{ 
      showLoading: noop,
      showOverlayLoader: noop,
      showInlineLoader: noop,
      showButtonLoader: noop,
      hideLoader: noop,
      isLoading: false
    }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = () => useContext(LoaderContext);

export default LoadingProvider;
